<template>
    <span style="margin-top: 30px">
        <div class="b-title">Testimonios</div>
        <div class="main-testimonials">
             <div class="margen"><img src="/image/resource/captura19.png" @click="modal = true; videoUrl = 19" class="box-shdow-image" alt="telemedicina" />
                <div style="text-align: center; font-size: 1.5rem; font-weight: 600">Dr. Jose Moron<img src="/image/flags/colombia.svg" width="25px"/></div>
            <div style="text-align: center; font-size: 1.2rem; margin-top: -7px">Medico Diabetólogo</div>
            </div>
            <div class="margen"><img src="/image/resource/captura20.png" @click="modal = true; videoUrl = 20" class="box-shdow-image" alt="telemedicina" />
                <div style="text-align: center; font-size: 1.5rem; font-weight: 600">Dra. Kalila Alvarado<img src="/image/flags/venezuela.svg" width="25px"/></div>
            <div style="text-align: center; font-size: 1.2rem; margin-top: -7px">Médico Internista & Reumatólogo</div>
            </div>
            <div class="margen"><img src="/image/resource/captura21.png" @click="modal = true; videoUrl = 21" class="box-shdow-image" alt="telemedicina" />
                <div style="text-align: center; font-size: 1.5rem; font-weight: 600">Dra. Genimar Garcia<img src="/image/flags/ecuador.svg" width="25px"/></div>
            <div style="text-align: center; font-size: 1.2rem; margin-top: -7px">Medico General</div>
            </div>
            <div class="margen"><img src="/image/resource/captura22.png" @click="modal = true; videoUrl = 22" class="box-shdow-image" alt="telemedicina" />
                <div style="text-align: center; font-size: 1.5rem; font-weight: 600">Dra. Gabriela Rodríguez<img src="/image/flags/ecuador.svg" width="25px"/></div>
            <div style="text-align: center; font-size: 1.2rem; margin-top: -7px">Médico Ginecólogo Obstetra</div>
            </div>
            <div class="margen"><img src="/image/resource/captura23.png" @click="modal = true; videoUrl = 23" class="box-shdow-image" alt="telemedicina" />
                <div style="text-align: center; font-size: 1.5rem; font-weight: 600">Dr. Nelson Marcano<img src="/image/flags/ecuador.svg" width="25px"/></div>
            <div style="text-align: center; font-size: 1.2rem; margin-top: -7px">Médico General</div>
            </div>
            <div class="margen"><img src="/image/resource/captura24.png" @click="modal = true; videoUrl = 24" class="box-shdow-image" alt="telemedicina" />
                <div style="text-align: center; font-size: 1.5rem; font-weight: 600">Dra. Diana Micolta<img src="/image/flags/colombia.svg" width="25px"/></div>
            <div style="text-align: center; font-size: 1.2rem; margin-top: -7px">Bacterióloga</div>
            </div>
            <div class="margen"><img src="/image/resource/captura25.png" @click="modal = true; videoUrl = 25" class="box-shdow-image" alt="telemedicina" />
                <div style="text-align: center; font-size: 1.5rem; font-weight: 600">Dr. Juan Jose Atilano<img src="/image/flags/mexico.svg" width="25px"/></div>
            <div style="text-align: center; font-size: 1.2rem; margin-top: -7px">Médico General</div>
            </div>

            <div class="margen"><img src="/image/resource/captura26.png" @click="modal = true; videoUrl = 26" class="box-shdow-image" alt="telemedicina" />
                <div style="text-align: center; font-size: 1.5rem; font-weight: 600">Betbiary Díaz Coral<img src="/image/flags/peru.svg" width="25px"/></div>
            <div style="text-align: center; font-size: 1.2rem; margin-top: -7px">Médico General</div>
            </div>
            <div class="margen"><img src="/image/resource/captura27.png" @click="modal = true; videoUrl = 27" class="box-shdow-image" alt="telemedicina" />
                <div style="text-align: center; font-size: 1.5rem; font-weight: 600">Dra. Carolina Beltran<img src="/image/flags/colombia.svg" width="25px"/></div>
            <div style="text-align: center; font-size: 1.2rem; margin-top: -7px">Otorrinolaringóloga</div>
            </div>
            <div class="margen"><img src="/image/resource/captura28.png" @click="modal = true; videoUrl = 28" class="box-shdow-image" alt="telemedicina" />
                <div style="text-align: center; font-size: 1.5rem; font-weight: 600">Dra. Erika Lara<img src="/image/flags/peru.svg" width="25px"/></div>
            <div style="text-align: center; font-size: 1.2rem; margin-top: -7px">Médico Obstetra</div>
            </div>

        <div class="margen"><img src="/image/resource/captura 1.PNG" @click="modal = true; videoUrl = 1" class="box-shdow-image" alt="telemedicina" />
            <div style="text-align: center; font-size: 1.5rem; font-weight: 600">Dr. Jorge Cedeño <img src="/image/flags/espana.svg" width="25px"/></div>
            <div style="text-align: center; font-size: 1.2rem; margin-top: -7px">Endocrinólogo</div>
        </div>
        <div class="margen"><img src="/image/resource/captura 2.PNG" @click="modal = true; videoUrl = 2" class="box-shdow-image" alt="telemedicina" />
            <div style="text-align: center; font-size: 1.5rem; font-weight: 600">Dra. Rosa Maria Gíl C.  <img src="/image/flags/venezuela.svg" width="25px"/></div>
            <div style="text-align: center; font-size: 1.2rem; margin-top: -7px">Endocrinólogo</div>
        </div>
        <div class="margen"><img src="/image/resource/captura 3.PNG" @click="modal = true; videoUrl = 3" class="box-shdow-image" alt="telemedicina" />
            <div style="text-align: center; font-size: 1.5rem; font-weight: 600">Dra. Yackeline Villamizar  <img src="/image/flags/ecuador.svg" width="25px"/></div>
            <div style="text-align: center; font-size: 1.2rem; margin-top: -7px">Médico Otorrinolaringólogo</div>
        </div>
        <div class="margen"><img src="/image/resource/captura 4.PNG" @click="modal = true; videoUrl = 4" class="box-shdow-image" alt="telemedicina" />
            <div style="text-align: center; font-size: 1.5rem; font-weight: 600">Dra. Miriam Albán  <img src="/image/flags/ecuador.svg" width="25px"/></div>
            <div style="text-align: center; font-size: 1.2rem; margin-top: -7px">Médico Ginecólogo Obstetra</div>
        </div>
        <div class="margen"><img src="/image/resource/captura 5.PNG" @click="modal = true; videoUrl = 5" class="box-shdow-image" alt="telemedicina" />
            <div style="text-align: center; font-size: 1.5rem; font-weight: 600">Dra. Lupe Idalma Lugo Díaz   <img src="/image/flags/ecuador.svg" width="25px"/></div>
            <div style="text-align: center; font-size: 1.2rem; margin-top: -7px">Médico Oftalmólogo</div>
        </div>
        <div class="margen"><img src="/image/resource/captura 6.PNG" @click="modal = true; videoUrl = 6" class="box-shdow-image" alt="telemedicina" />
            <div style="text-align: center; font-size: 1.5rem; font-weight: 600">Dra. Julia Castro <img src="/image/flags/ecuador.svg" width="25px"/></div>
            <div style="text-align: center; font-size: 1.2rem; margin-top: -7px">Médico Fisiatra</div>
        </div>
        <div class="margen"><img src="/image/resource/captura 7.PNG" @click="modal = true; videoUrl = 7" class="box-shdow-image" alt="telemedicina" />
                <div style="text-align: center; font-size: 1.5rem; font-weight: 600">Dra. Luis Arocha <img src="/image/flags/ecuador.svg" width="25px"/></div>
            <div style="text-align: center; font-size: 1.2rem; margin-top: -7px">Médico Psiquiatra</div>
            </div>
            <div class="margen"><img src="/image/resource/captura 8.PNG" @click="modal = true; videoUrl = 8" class="box-shdow-image" alt="telemedicina" />
                <div style="text-align: center; font-size: 1.5rem; font-weight: 600">Dra. Karla Viña   <img src="/image/flags/ecuador.svg" width="25px"/></div>
            <div style="text-align: center; font-size: 1.2rem; margin-top: -7px">Médico Ocupacional</div>
            </div>
            <div class="margen"><img src="/image/resource/captura 9.PNG" @click="modal = true; videoUrl = 9" class="box-shdow-image" alt="telemedicina" />
                <div style="text-align: center; font-size: 1.5rem; font-weight: 600">Dra. Aura Martinez  <img src="/image/flags/ecuador.svg" width="25px"/></div>
            <div style="text-align: center; font-size: 1.2rem; margin-top: -7px">Médico Ginecólogo Obstetra</div>
            </div>

            <div class="margen"><img src="/image/resource/captura 10.PNG" @click="modal = true; videoUrl = 10" class="box-shdow-image" alt="telemedicina" />
                <div style="text-align: center; font-size: 1.5rem; font-weight: 600">Dr. Juan Carlos Sjostrand  <img src="/image/flags/venezuela.svg" width="25px"/></div>
            <div style="text-align: center; font-size: 1.2rem; margin-top: -7px">Médico Traumatólogo</div>
            </div>
            <div class="margen"><img src="/image/resource/captura11.PNG" @click="modal = true; videoUrl = 11" class="box-shdow-image" alt="telemedicina" />
                <div style="text-align: center; font-size: 1.5rem; font-weight: 600">Dra. Gardenia Rodriguez  <img src="/image/flags/mexico.svg" width="25px"/></div>
            <div style="text-align: center; font-size: 1.2rem; margin-top: -7px">Médico Cirujano</div>
            </div>
            <div class="margen"><img src="/image/resource/captura12.PNG" @click="modal = true; videoUrl = 12" class="box-shdow-image" alt="telemedicina" />
                <div style="text-align: center; font-size: 1.5rem; font-weight: 600">Dr. Wilfredo Hernandez   <img src="/image/flags/estados-unidos-de-america.svg" width="25px"/></div>
            <div style="text-align: center; font-size: 1.2rem; margin-top: -7px">Médico Cirujano</div>
            </div>
            <div class="margen"><img src="/image/resource/captura13.PNG" @click="modal = true; videoUrl = 13" class="box-shdow-image" alt="telemedicina" />
                <div style="text-align: center; font-size: 1.5rem; font-weight: 600">Dr. Alejandro Jimenez   <img src="/image/flags/mexico.svg" width="25px"/></div>
            <div style="text-align: center; font-size: 1.2rem; margin-top: -7px">Médico Cirujano - Laparoscopista</div>
            </div>

            <div class="margen"><img src="/image/resource/captura14.PNG" @click="modal = true; videoUrl = 14" class="box-shdow-image" alt="telemedicina" />
                <div style="text-align: center; font-size: 1.5rem; font-weight: 600">Dra. Amalia Ferreira <img src="/image/flags/uruguay.svg" width="25px"/></div>
            <div style="text-align: center; font-size: 1.2rem; margin-top: -7px">Odontóloga</div>
            </div>
            <div class="margen" style="text-align: center"><img src="/image/resource/captura15.PNG" @click="modal = true; videoUrl = 15" class="box-shdow-image" alt="telemedicina" />
                <div style="text-align: center; font-size: 1.5rem; font-weight: 600">Dra. Carlota Chaca <img src="/image/flags/ecuador.svg" width="25px"/></div>
            <div style="text-align: center; font-size: 1.2rem; margin-top: -7px">Médico Escolar</div>
            </div>
            <div class="margen"><img src="/image/resource/captura16.PNG" @click="modal = true; videoUrl = 16" class="box-shdow-image" alt="telemedicina" />
                <div style="text-align: center; font-size: 1.5rem; font-weight: 600">Dr. Germanico Zambrano<img src="/image/flags/ecuador.svg" width="25px"/></div>
            <div style="text-align: center; font-size: 1.2rem; margin-top: -7px">Médico Psiquiatra - Sexólogo</div>
            </div>
            <div class="margen" style="text-align: center"><img src="/image/resource/captura17.PNG" @click="modal = true; videoUrl = 17" class="box-shdow-image" alt="telemedicina" />
                <div style="text-align: center; font-size: 1.5rem; font-weight: 600">Mercedes Dominguez<img src="/image/flags/ecuador.svg" width="25px"/></div>
            <div style="text-align: center; font-size: 1.2rem; margin-top: -7px">Espc. Med. familiar - MCs. Geriatría</div>
            </div>
            <div class="margen"><img src="/image/resource/captura18.PNG" @click="modal = true; videoUrl = 18" class="box-shdow-image" alt="telemedicina" />
                <div style="text-align: center; font-size: 1.5rem; font-weight: 600">MSc. Guadalupe Godoy<img src="/image/flags/venezuela.svg" width="25px"/></div>
            <div style="text-align: center; font-size: 1.2rem; margin-top: -7px">Creadora de Maternidad Efectiva</div>
            </div>

    </div>
         <transition name="modal" v-if="modal">
            <div class="modal-mask">
              <div class="modal-wrapper">
                <div class="modal-container">
                  <div class="modal-body">
                      <div v-if="videoUrl === 1"><iframe class="youtube" src="https://www.youtube.com/embed/jfxUDUqRmeQ" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>
                      <div v-if="videoUrl === 2"><iframe class="youtube" src="https://www.youtube.com/embed/-WwusOonvf8" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>
                      <div v-if="videoUrl === 3"><iframe class="youtube" src="https://www.youtube.com/embed/j9YfZHdjaZ0" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>
                      <div v-if="videoUrl === 4"><iframe class="youtube" src="https://www.youtube.com/embed/1BF6xVgrGdk" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>
                      <div v-if="videoUrl === 5"><iframe class="youtube" src="https://www.youtube.com/embed/skzG9RCHm0A" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>
                      <div v-if="videoUrl === 6"><iframe class="youtube" src="https://www.youtube.com/embed/FXX_IFy_7Y4" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>
                      <div v-if="videoUrl === 7"><iframe class="youtube" src="https://www.youtube.com/embed/ayYMJu8D_Qw" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>

                      <div v-if="videoUrl === 8"><iframe class="youtube" src="https://www.youtube.com/embed/ddbrC2wGjbk" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>
                      <div v-if="videoUrl === 9"><iframe class="youtube" src="https://www.youtube.com/embed/MfRzC8Rr_HM" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>
                      <div v-if="videoUrl === 10"><iframe class="youtube" src="https://www.youtube.com/embed/mv9Cj2y8_r0" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>
                      <div v-if="videoUrl === 11"><iframe class="youtube" src="https://www.youtube.com/embed/rRECCQJEgJw" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>
                      <div v-if="videoUrl === 12"><iframe class="youtube" src="https://www.youtube.com/embed/Dsf8emoUANQ" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>
                      <div v-if="videoUrl === 13"><iframe class="youtube" src="https://www.youtube.com/embed/zfElE-SbMFs" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>

                      <div v-if="videoUrl === 14"><iframe class="youtube" src="https://www.youtube.com/embed/PHvxlo0NQ6M" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>
                      <div v-if="videoUrl === 15"><iframe class="youtube" src="https://www.youtube.com/embed/ZFXCmmIlKLM" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>
                      <div v-if="videoUrl === 16"><iframe class="youtube" src="https://www.youtube.com/embed/wus3pwGeQrw" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>
                      <div v-if="videoUrl === 17"><iframe class="youtube" src="https://www.youtube.com/embed/QCPAFG5-cOM" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>
                      <div v-if="videoUrl === 18"><iframe class="youtube" src="https://www.youtube.com/embed/O0Qd_7ewBlo" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>

                      <div v-if="videoUrl === 19"><iframe class="youtube" src="https://www.youtube.com/embed/90DpkufAfOU" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>
                      <div v-if="videoUrl === 20"><iframe class="youtube" src="https://www.youtube.com/embed/zHyQgcUnXBA" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>
                      <div v-if="videoUrl === 21"><iframe class="youtube" src="https://www.youtube.com/embed/b8JZcpTmEnk" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>
                      <div v-if="videoUrl === 22"><iframe class="youtube" src="https://www.youtube.com/embed/SxlXd8YSs_Y" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>
                      <div v-if="videoUrl === 23"><iframe class="youtube" src="https://www.youtube.com/embed/qwkfYMBx5pY" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>
                      <div v-if="videoUrl === 24"><iframe class="youtube" src="https://www.youtube.com/embed/R2Yne-b9G08" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>
                      <div v-if="videoUrl === 25"><iframe class="youtube" src="https://www.youtube.com/embed/YOjH0EU6U4o" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>
                      <div v-if="videoUrl === 26"><iframe class="youtube" src="https://www.youtube.com/embed/xjusi5IhYFw" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>
                      <div v-if="videoUrl === 27"><iframe class="youtube" src="https://www.youtube.com/embed/yAgS845jyCk" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>
                      <div v-if="videoUrl === 28"><iframe class="youtube" src="https://www.youtube.com/embed/HpzLYSJdDRo" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>


                      <div><button @click="modal = false" class="btn btn-primary">cerrar</button></div>
                  </div>
                </div>
              </div>
            </div>
          </transition>
    </span>
</template>
<style scoped>
    .b-title{
        font-size: 4rem;
        line-height: 5rem;
        font-weight: 800;
        text-align: center;
        font-family: 'Gayathri', sans-serif;
        color: #4D5CD3;
    }
    .box-shdow-image{
        -webkit-box-shadow: -5px 5px 64px -17px rgba(191,191,191,1);
        -moz-box-shadow: -5px 5px 64px -17px rgba(191,191,191,1);
        box-shadow: -5px 5px 64px -17px rgba(191,191,191,1);
        cursor: pointer;
        width: 220px;
        border-radius: 10px;
        border: 3px solid #4D5CD3;
        transition: box-shadow 0.3s ease-in-out;
    }
    .box-shdow-image:hover{
        -webkit-box-shadow: 0px -1px 18px 0px rgba(0,0,0,0.75);
        -moz-box-shadow: 0px -1px 18px 0px rgba(0,0,0,0.75);
        box-shadow: 0px -1px 18px 0px rgba(0,0,0,0.75);
    }

    .main-testimonials{
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-around;
        width: 100%;
        padding: 30px 0
    }

    .margen{
        margin: 20px 30px;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
    .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .3s ease;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }

    .modal-container {
        width: 600px;
        margin: 0px auto;
        padding: 10px 10px;
        background-color: #fff;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        transition: all .3s ease;
        font-family: Helvetica, Arial, sans-serif;
        display: flex;
        justify-content: center;
    }
    .youtube{
        width: 100%;
        height: 400px;
    }
    .modal-header h3 {
        margin-top: 0;
        color: #42b983;
    }

    .modal-body {
        margin: 5px 0;
    }

    .modal-default-button {
        float: right;
    }


    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }



    @media (min-width: 481px) and (max-width: 767px) {
        .main-testimonials{
            display: flex;
            flex-direction: column;
        }
        .margen{
            margin: 10px 0;
        }
        .modal-container {
            width: 480px;

        }
    }

    @media (min-width: 120px) and (max-width: 480px) {
        .main-testimonials{
            display: flex;
            flex-direction: column;
        }
        .margen{
            margin: 10px 0;
        }
        .modal-container {
            width: 320px;

        }
    }

</style>
<script>
    import {mapState} from 'vuex'
    import axios from 'axios'
    export default {
        name: 'testimonials',
        components: {

        },
        created(){

        },
        data(){
            return {
                videoUrl: '',
                modal:false,
            }
        },
        computed: {
            ...mapState,


        },
        methods:{

        }

    }
</script>
